import api from '@/api/api';

const DOMAIN = '/companies';
const DOMAIN_PLANS = '/company-plans';

const get = async (
	params?: Companies.CompanyParams,
): Promise<Companies.GetCompaniesResponse> => {
	const { data } = await api.get(`${DOMAIN}`, { params });
	return data;
};

const getById = async (id: string): Promise<Companies.CompanyDetail> => {
	const { data } = await api.get(`${DOMAIN}`, { params: { id } });
	return data;
};

const getMyCompany = async (): Promise<Companies.MyCompany | null> => {
	const { data } = await api.get(`${DOMAIN}/my-company`);
	return data;
};

const create = async (body: Companies.Create): Promise<Companies.Company> => {
	const { data } = await api.post(`${DOMAIN}`, body);
	return data;
};

const patch = async (
	id: string,
	body: Companies.Update,
): Promise<Companies.Company> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const updateStatus = async (
	id: string,
	body: { active: boolean },
): Promise<void> => {
	await api.patch(`${DOMAIN}/${id}/status`, body);
};

const getPlans = async (params?: {
	id?: string;
	active?: boolean;
}): Promise<Companies.Plan[]> => {
	const { data } = await api.get(`${DOMAIN_PLANS}`, { params });
	return data;
};

const createPlan = async (
	body: Companies.CreatePlan,
): Promise<Companies.Plan> => {
	const { data } = await api.post(`${DOMAIN_PLANS}`, body);
	return data;
};

const updatePlan = async (
	id: string,
	body: Companies.UpdatePlan,
): Promise<Companies.Plan> => {
	const { data } = await api.patch(`${DOMAIN_PLANS}/${id}`, body);
	return data;
};

const removePlan = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN_PLANS}/${id}`);
};

const getSubscriptions = async (
	params?: Companies.SubscriptionParams,
): Promise<Companies.Subscription[]> => {
	const { data } = await api.get(`${DOMAIN_PLANS}/subscriptions`, { params });
	return data;
};

const createSubscription = async (
	companyId: string,
	planId: string,
	successUrl: string,
	cancelUrl: string,
): Promise<{ url: string }> => {
	const { data } = await api.post(
		`${DOMAIN_PLANS}/subscriptions/${companyId}/${planId}`,
		{ success_url: successUrl, cancel_url: cancelUrl },
	);
	return data;
};

const updateSubscription = async (
	id: string,
	body: Companies.UpdateSubscription,
): Promise<Companies.Subscription> => {
	const { data } = await api.patch(
		`${DOMAIN_PLANS}/subscriptions/${id}`,
		body,
	);
	return data;
};

const cancelSubscription = async (
	id: string,
	body: Companies.CancelSubscription,
): Promise<void> => {
	await api.patch(`${DOMAIN_PLANS}/subscriptions/${id}/cancel`, body);
};

const linkClub = async (
	companyId: string,
	clubId: string,
): Promise<Companies.CompanyClubDetail> => {
	const { data } = await api.post(`${DOMAIN}/${companyId}/clubs/${clubId}`);
	return data;
};

const unlinkClub = async (companyId: string, clubId: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${companyId}/clubs/${clubId}`);
};

const CompanyService = {
	get,
	getById,
	getMyCompany,
	create,
	patch,
	remove,
	updateStatus,
	getPlans,
	createPlan,
	updatePlan,
	removePlan,
	getSubscriptions,
	createSubscription,
	updateSubscription,
	cancelSubscription,
	linkClub,
	unlinkClub,
};

export { CompanyService };
